import axios from "axios";

const postConsultationTalep = async (baseUrl, token, doctorId, consultTalepBody) => {

    const config = {
        headers: { Authorization: `Bearer ${token}` }
    };

    let putResponse = null

    await axios.post(baseUrl + "/doctor/" + doctorId + "/appointment/consult", consultTalepBody, config)
        .then((res) => {
            putResponse = {
                status: res.data.status,
                data: res.data.data
            }
        }).catch((error) => {
            if (error.response !== undefined) {
                putResponse = {
                    status: error.response.status,
                    data: error.response.status
                }
            }
        });
    return putResponse
}

export default postConsultationTalep;